import React from 'react';
import styled from 'styled-components';
import Folder from '@assets/images/folder.svg';
import FolderBlack from '@assets/images/folder_black.svg';

const DownloadWrapper = styled.div`
  height: 30px;
  margin-bottom: 10px;
  display: flex;
  color: ${props => props.darkMode ? '#ffffff' : '#121212'};

  &:last-child {
    margin-bottom: 0;
  }

  a {
    text-decoration: none;
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 15px;
    line-height: 30px;
    margin-left: 15px;
    cursor: pointer;
    color: ${props => props.darkMode ? '#ffffff' : '#121212'};
  }
`;

export const DownloadFile = ({ fileName, darkMode, file, extension, name }) => {
  
  return (
    <DownloadWrapper darkMode={darkMode}>
      {darkMode ? <Folder/> : <FolderBlack/>}
      <a href={file} download={`${name || fileName}${extension || '.zip'}`}>{ fileName }</a>
    </DownloadWrapper>
  );
};
